<template>
  <div class="d-flex flex-column vs-box-wrapper" v-if="currentSigner">
    <div class="participant-docu-details custom-height m-48 d-flex flex-column" v-if="currentPage === 0">
      <p class="verify-name m-0 pb-48">{{ currentSigner.header }}</p>
      <div class="row edu-btn-group ">
        <div class="col-6 col-md-6">
          <button class="btn leavestudy secondary-bg text-white" @click="$emit('cancelled')" v-translate:NO_TEXT="lang">
            No
          </button>
        </div>
        <div class="col-6 col-md-6">
          <button class="btn leave_study_cntue" @click="changePage(1)" v-translate:YES_TEXT="lang">
            Yes
          </button>
        </div>
      </div>
    </div>
    <div v-if="currentPage === 1" class="participant-docu-details custom-height m-48 d-flex flex-column">
      <div class="participant-docu-details custom-height m-48 d-flex flex-column" :key="`${currentSigner.name}+${currentPage}`">
        <p class="vs-participant-title">{{ currentSigner.name }}</p>
        <p class="vs-participant-msg">{{ currentSigner.description }}</p>
        <div class="form-group mb-24">
          <input v-translate:first_name.placeholder="lang" class="form-control" placeholder="First Name" v-model="signerData.firstName" />
        </div>
        <div class="form-group mb-24">
          <input v-translate:last_name.placeholder="lang" class="form-control" placeholder="Last Name" v-model="signerData.lastName" />
        </div>
      </div>
      <button class="btn leave_study_cntue primary-bg" :disabled="signerData.firstName === '' || signerData.lastName === ''" @click="changePage(2)" v-translate:text_signin_button="lang">
        Next
      </button>
    </div>
    <div v-else-if="currentPage === 2" class="profile-signature-wrap1 pw-height-100 d-flex flex-column sign-consent-2">
      <div class="vs-box-wrapper pt-20 pr-50" :key="`initials+${currentPage}`">
        <p class="vs-participant-title">
          {{ this.widget.translate("label_initials", "Initials") }}
        </p>
        <p>
          {{ this.widget.translate("label_initial_info", "Please enter your initials below.") }}
        </p>
        <div class="consent-sign-pad pt-8 mt-50 mb-100">
          <Initial :lang="lang" key="initials" v-model="signerData.initialImageData"></Initial>
        </div>
        <button class="btn btn-submit primary-bg mb-40" :disabled="signerData.initialImageData === null" @click="changePage(3)" v-translate:text_signin_button="lang">
          Next
        </button>
      </div>
    </div>
    <div v-else-if="currentPage === 3" class="profile-signature-wrap1 pw-height-100 d-flex flex-column sign-consent-2">
      <div class="vs-box-wrapper pt-20 pr-50" :key="`signature+${currentPage}`">
        <p class="vs-participant-title">
          {{ this.widget.translate("rsb_consent_signature_title", "Signature") }}
        </p>
        <p>
          {{ this.widget.translate("label_signature_info", "Please enter your signature below.") }}
        </p>
        <div class="consent-sign-pad pt-8 mt-50 mb-100">
          <Initial :lang="lang" key="signature" v-model="signerData.signatureImageData"></Initial>
        </div>
        <br />
        <button class="btn leave_study_cntue primary-bg  mb-40" :disabled="signerData.signatureImageData === null" @click="completedSignerDetails" v-translate:text_signin_button="lang">
          Next
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Initial from "@/components/common/initials";
import { Widget } from "@/components/services/participant-service";

export default {
  name: "SignerDetailsForm",
  props: ["page", "role", "value", "requiredFields"],
  components: { Initial },
  data() {
    return {
      widget: new Widget(),
      currentPage: this.role.includes("participant") && this.page === 0 ? 1 : this.page,
      currentSignerRoleName: this.role,
      signerRoleObject: this.value,
      signerData: {
        firstName: this.value && this.value.firstName ? this.value.firstName : "",
        lastName: this.value && this.value.lastName ? this.value.lastName : "",
        initialImageData: this.value && this.value.initialImageData ? this.value.initialImageData : "",
        signatureImageData: this.value && this.value.signatureImageData ? this.value.signatureImageData : ""
      }
    };
  },
  watch: {
    page(val) {
      this.currentPage = this.role.includes("participant") && val === 0 ? 1 : val;
    },
    role(val) {
      this.currentSignerRoleName = val;
    },
    value(val) {
      this.signerData = {
        firstName: val && val.firstName ? val.firstName : "",
        lastName: val && val.lastName ? val.lastName : "",
        initialImageData: val && val.initialImageData ? val.initialImageData : "",
        signatureImageData: val && val.signatureImageData ? val.signatureImageData : ""
      };
    }
  },
  computed: {
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    currentSigner() {
      const roles = Object.keys(this.roles); //get keys from object as an array
      let signer = null;
      roles.forEach(key => {
        //loop through keys array
        if (this.currentSignerRoleName.includes(key)) {
          signer = this.roles[key];
        }
      });
      signer.name = signer.name.replace("1", this.currentSignerRoleName.split("")[this.currentSignerRoleName.length - 1]);
      return signer;
    },
    roles() {
      return {
        caregiver: {
          title: "Parent/Legal Guardian/Caregive",
          header: this.widget.translate("label_parent_confirmation", "Will a Parent/Legal Guardian/Caregiver be signing?"),
          name: this.widget.translate("label_caregiver_one", "Parent/Legal Guardian/Caregiver 1"),
          description: this.widget.translate("label_user_role_caregiver", "Please confirm you are the parent/legal guardian/caregiver by entering your first and last name.").replace("\\n", " ")
        },
        observer: {
          title: "Observer",
          header: this.widget.translate("label_observer_confirmation", "Will an Observer be signing?"),
          name: this.widget.translate("label_observer_one", "Observer 1"),
          description: this.widget.translate("label_user_role_observer", "Please confirm you are the observer by entering your first and last name.").replace("\\n", " ")
        },
        participant: {
          title: "Participant",
          header: "Will an Participant be signing?",
          name: this.widget.translate("label_participant", "Participant"),
          description: this.widget.translate("label_user_role_participant", "Please confirm you are the participant by entering your first and last name.").replace("\\n", " ")
        }
      };
    }
  },
  methods: {
    changePage(toOld) {
      let to = toOld;
      if (this.currentSignerRoleName.includes("participant") && to === 0) {
        to = 1;
      }

      if (to === 2 && !this.requiredFields.includes("initials") && this.requiredFields.includes("signature")) {
        to = 3;
      }

      if (to === 3 && !this.requiredFields.includes("signature")) {
        this.completedSignerDetails();
      } else {
        this.currentPage = to;
        this.$emit("pageChange", this.currentPage);
      }
    },
    completedSignerDetails() {
      this.$emit("change", this.signerData);
      this.$emit("input", this.signerData);
    }
  }
};
</script>
